import React, { useState } from 'react';
import { Countdown, Button, TrustBar } from './Shared';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
type Option = {
  id: string;
  icon: string;
  name: string;
  detail: string;
  oldPrice: string;
  price: string;
  cta: string;
  href: string;
  top?: boolean;
  save?: string;
};
const OPTIONS: Option[] = [{
  id: 't1',
  icon: '📘',
  name: 'PACK TRAMO 1 · Inicial',
  detail: '8 tomos + 6 bonos',
  oldPrice: '$1.990',
  price: '$890',
  cta: '🟠 COMPRAR PACK TRAMO 1 →',
  href: 'https://tufenixdigital.store/cart/53832899985772:1'
}, {
  id: 't2',
  icon: '📗',
  name: 'PACK TRAMO 2 · 1° y 2°',
  detail: '8 tomos + 6 bonos',
  oldPrice: '$1.990',
  price: '$890',
  cta: '🟠 COMPRAR PACK TRAMO 2 →',
  href: 'https://tufenixdigital.store/cart/53939688046956:1'
}, {
  id: 'mega',
  icon: '🏆',
  name: 'MEGAPACK COMPLETO',
  detail: '32 tomos + 24 bonos',
  oldPrice: '$7.960',
  price: '$2.490',
  cta: '⭐ SÍ · QUIERO EL MEGAPACK →',
  href: 'https://tufenixdigital.store/cart/53889590722924:1',
  top: true,
  save: 'AHORRÁS $1.070'
}, {
  id: 't3',
  icon: '📙',
  name: 'PACK TRAMO 3 · 3° y 4°',
  detail: '8 tomos + 6 bonos',
  oldPrice: '$1.990',
  price: '$890',
  cta: '🟠 COMPRAR PACK TRAMO 3 →',
  href: 'https://tufenixdigital.store/cart/53939663012204:1'
}, {
  id: 't4',
  icon: '📓',
  name: 'PACK TRAMO 4 · 5° y 6°',
  detail: '8 tomos + 6 bonos',
  oldPrice: '$1.990',
  price: '$890',
  cta: '🟠 COMPRAR PACK TRAMO 4 →',
  href: 'https://tufenixdigital.store/cart/53939690602860:1'
}];
export function Precios() {
  const [selected, setSelected] = useState('mega');
  const current = OPTIONS.find(o => o.id === selected) ?? OPTIONS[2];
  return <>
      {/* SECCIÓN 6: URGENCIA */}
      <section className="py-12 px-4 bg-orange-50 border-y border-orange-100 text-center" data-id="element-85">
        <div className="max-w-3xl mx-auto" data-id="element-86">
          <div className="inline-block bg-red-100 text-red-700 px-4 py-1 rounded-full text-sm font-bold mb-4 flex items-center justify-center gap-2 w-max mx-auto" data-id="element-87">
            <span className="w-2 h-2 rounded-full bg-red-600 animate-pulse" data-id="element-88"></span>
            Cupos limitados · Quedan pocos
          </div>
          <h2 className="text-2xl md:text-3xl font-display font-bold text-brand-deep mb-4" data-id="element-89">
            ⏰ PRECIO DE LANZAMIENTO TERMINA EN:
          </h2>
          <Countdown data-id="element-90" />
          <p className="text-lg text-brand-text font-medium mt-4" data-id="element-91">
            Después vuelve a su precio real y no vuelve esta oferta.
          </p>
        </div>
      </section>

      {/* SECCIÓN 7: PRECIOS */}
      <section id="precios" className="py-16 px-4 bg-brand-base scroll-mt-10" data-id="element-92">
        <div className="max-w-xl mx-auto" data-id="element-93">
          <div className="text-center mb-10" data-id="element-94">
            <h2 className="text-3xl md:text-5xl font-display font-bold text-brand-deep mb-3" data-id="element-95">
              Elegí tu <span className="text-brand-orange" data-id="element-96">Aula de Éxitos</span>
            </h2>
            <p className="text-lg text-brand-text font-medium" data-id="element-97">
              Todas las opciones incluyen los 6 bonos estratégicos
            </p>
          </div>

          {/* Selectable rows */}
          <div role="radiogroup" aria-label="Opciones de compra" className="space-y-4 mb-8" data-id="element-98">
            {OPTIONS.map((opt, i) => {
            const isActive = selected === opt.id;
            return <button key={opt.id} type="button" role="radio" aria-checked={isActive} onClick={() => setSelected(opt.id)} className={`relative w-full text-left rounded-2xl p-4 md:p-5 border-2 transition-all flex items-center gap-4 ${isActive ? 'border-brand-orange bg-orange-50 shadow-[0_8px_24px_rgba(245,124,0,0.18)]' : 'border-gray-200 bg-white hover:border-brand-sky'}`} data-id="element-99">
                  {/* TOP badge */}
                  {opt.top && <span className="absolute -top-3 right-4 bg-brand-orange text-white text-xs font-bold px-3 py-0.5 rounded-full shadow-md" data-id="element-100">
                      ⭐ TOP
                    </span>}

                  {/* Radio */}
                  <span className={`flex-shrink-0 w-6 h-6 rounded-full border-2 flex items-center justify-center ${isActive ? 'border-brand-orange' : 'border-gray-300'}`} data-id="element-101">
                    {isActive && <span className="w-3 h-3 rounded-full bg-brand-orange" data-id="element-102" />}
                  </span>

                  {/* Label */}
                  <div className="flex-1 min-w-0" data-id="element-103">
                    <div className="font-display font-bold text-brand-deep text-base md:text-lg flex items-center gap-2 flex-wrap" data-id="element-104">
                      <motion.span className="text-xl inline-block" animate={{
                    rotate: [0, -8, 8, -8, 0],
                    y: [0, -2, 0]
                  }} transition={{
                    duration: 2.4,
                    repeat: Infinity,
                    repeatDelay: 1.2,
                    ease: 'easeInOut',
                    delay: i * 0.25
                  }} data-id="element-105">
                        {opt.icon}
                      </motion.span>
                      <span data-id="element-106">{opt.name}</span>
                    </div>
                    <div className="text-sm text-brand-text mt-0.5" data-id="element-107">
                      {opt.detail}
                    </div>
                    {opt.save && <span className="inline-block mt-2 bg-brand-greenSoft text-brand-green border border-green-200 text-xs font-bold px-2 py-0.5 rounded-full" data-id="element-108">
                        🟢 {opt.save}
                      </span>}

                    {/* Mini CTA por oferta */}
                    <a href={opt.href} target="_blank" rel="noopener noreferrer" onClick={e => e.stopPropagation()} className="mt-2 inline-flex items-center gap-1 bg-brand-orange hover:bg-[#EF6C00] text-white text-xs font-bold px-3 py-1.5 rounded-full shadow-sm transition-colors active:scale-95" data-id="element-109">
                      Lo quiero ahora!
                      <ArrowRight className="w-3 h-3" data-id="element-110" />
                    </a>
                  </div>

                  {/* Price */}
                  <div className="flex-shrink-0 text-right" data-id="element-111">
                    <div className="text-brand-gray line-through text-sm font-medium" data-id="element-112">
                      {opt.oldPrice}
                    </div>
                    <div className="font-display font-bold text-brand-deep text-2xl md:text-3xl" data-id="element-113">
                      {opt.price}
                    </div>
                    <div className="text-xs text-brand-gray font-semibold" data-id="element-114">
                      UY
                    </div>
                  </div>
                </button>;
          })}
          </div>

          {/* Dynamic CTA */}
          <motion.div key={current.id} initial={{
          opacity: 0.6
        }} animate={{
          opacity: 1
        }} transition={{
          duration: 0.2
        }} data-id="element-115">
            <Button href={current.href} variant={current.id === 'mega' ? 'success' : 'primary'} className="py-5 text-lg md:text-xl" data-id="element-116">
              {current.cta}
            </Button>
          </motion.div>

          <motion.p animate={{
          opacity: [0.65, 1, 0.65]
        }} transition={{
          duration: 2,
          repeat: Infinity,
          ease: 'easeInOut'
        }} className="mt-4 text-center text-sm font-semibold text-brand-orange flex items-center justify-center gap-1.5" data-id="element-117">
            <motion.span aria-hidden="true" animate={{
            scale: [1, 1.3, 1],
            rotate: [0, -12, 12, 0]
          }} transition={{
            duration: 1.4,
            repeat: Infinity,
            ease: 'easeInOut'
          }} className="inline-block" data-id="element-118">
              ⚡
            </motion.span>
            El precio actual es exclusivo para los primeros 200 compradores
          </motion.p>

          <div className="mt-6" data-id="element-119">
            <TrustBar data-id="element-120" />
          </div>
        </div>
      </section>
    </>;
}